import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { createBackendErrorMessages, createErrorMessages, messagesReceived } from "./message";

import ObjectUtils from "../utils/ObjectUtils";
import rest from "../common/rest";
import FileSaver from "file-saver";

const { getDeepProperty } = ObjectUtils;

const TIME_FACET = "REPORT.TIME_FACET";
const CLEAR_CHARTS = "REPORT.CLEAR_CHARTS";
const LABEL_CHANGED_ACTION = "REPORT.LABEL_CHANGED_ACTION";
const PROPERTY_CHANGED_ACTION = "REPORT.PROPERTY_CHANGED_ACTION";
const FIRST_TWO_DIGIT_NUMBER = 10;
const MONTH_ZERO_BASED_INDEX_COMPENSATION = 1;

export const RECEIVED_TIME_FACET = "timeFacet";
export const LABEL = "label";

const initialState = {
  [RECEIVED_TIME_FACET]: null,
  [LABEL]: []
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case TIME_FACET:
      newState = {
        ...state,
        [RECEIVED_TIME_FACET]: action[RECEIVED_TIME_FACET]
      };
      break;
    case CLEAR_CHARTS:
      newState = Object.assign({}, state, initialState);
      break;
    case LABEL_CHANGED_ACTION:
      newState = {
        ...state,
        [LABEL]: action[LABEL]
      };
      break;
    case PROPERTY_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    default:
      newState = { ...state };
      break;
  }
  return newState;
}

export function getCsv() {
  return (dispatch, getState) => {
    let indicatorProgram = getDeepProperty(getState(), "fundingArea", "selectedProgram", "indicatorsModalDialog");
    if (indicatorProgram && indicatorProgram.id) {
      rest
        .doGet(
          `/survey/evaluations/frequency/frequencyAnalysisByProgram?programRefId=${indicatorProgram.id}`,
          "text/csv"
        )
        .then(
          (response) => {
            try {
              const csv = response.response || response;
              let blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8" });
              FileSaver.saveAs(blob, "ProgramStatistic_" + getCurrentDateString() + ".csv");
            } catch (err) {
              dispatch(messagesReceived(createErrorMessages(err)));
            }
          },
          (reason) => {
            dispatch(messagesReceived(createBackendErrorMessages(reason)));
          }
        );
    }
  };
}

function getCurrentDateString() {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + MONTH_ZERO_BASED_INDEX_COMPENSATION;
  let yyyy = today.getFullYear();
  if (dd < FIRST_TWO_DIGIT_NUMBER) {
    dd = "0" + dd;
  }

  if (mm < FIRST_TWO_DIGIT_NUMBER) {
    mm = "0" + mm;
  }

  return dd + "." + mm + "." + yyyy;
}

export function getTimeFacetForEvaluation() {
  return (dispatch) => {
    rest.doGet(`/survey/evaluations/facets/time`).then(
      (time) => {
        dispatch(loadSuccessfulTimeFacet(time.timeFacets[0]));
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function removeDataForAnalyticsReport() {
  return (dispatch) => {
    dispatch(clearCharts());
    dispatch(propertyChange());
  };
}

export function clearCharts() {
  return {
    [TYPE_KEY]: CLEAR_CHARTS
  };
}

export function loadSuccessfulTimeFacet(data) {
  return {
    [TYPE_KEY]: TIME_FACET,
    [RECEIVED_TIME_FACET]: data
  };
}

export function labelChange(label) {
  return {
    [TYPE_KEY]: LABEL_CHANGED_ACTION,
    [LABEL]: label
  };
}

/**
 * Change Property Action
 */
export function propertyChange(propertyName, propertyValue) {
  return {
    [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
    [PROPERTY_NAME]: propertyName,
    [PROPERTY_VALUE]: propertyValue
  };
}
